import { render, staticRenderFns } from "./TransportEdit.vue?vue&type=template&id=44359f3d&"
import script from "./TransportEdit.vue?vue&type=script&lang=js&"
export * from "./TransportEdit.vue?vue&type=script&lang=js&"
import style0 from "./TransportEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports